import { Button } from "@mui/material";
import React from "react";
import { ModalButtonContainer, NegativeModalButton, PositiveModalButton } from "../../components/Button";
import { useModal } from "../../components/modal";
import { CustomTextField } from "../../components/TextFields";
import { Row } from "../../global/styledComponents";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

const schema = yup.object().shape({
    voucherId: yup.string().required("شناسه کوپن الزامی است."),
    amount: yup.number().required(" مقدار الزامی است."),
    description: yup.string().required(" توضیحات الزامی است."),
});

export default function AddModal() {
    const { setShow } = useModal();
    const {
        setValue,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm({
        resolver: yupResolver(schema),
    });
    return (
        <React.Fragment>
            <Row gap=".5rem">
                <CustomTextField
                    variant="outlined"
                    placeholder="شناسه کوپن را وارد کنید."
                    label="شناسه کوپن"
                    required
                    onChange={(e) => setValue("voucherId", e.target.value)}
                    value={watch("voucherId")}
                    error={!!errors.voucherId}
                    helperText={errors.voucherId?.message}
                />
                <CustomTextField
                    variant="outlined"
                    placeholder="مقدار را وارد کنید."
                    label="مقدار"
                    required
                    onChange={(e) => setValue("amount", Number(e.target.value))}
                    value={watch("amount")}
                    error={!!errors.amount}
                    helperText={errors.amount?.message}
                />
            </Row>
            <CustomTextField
                variant="outlined"
                placeholder="توضیحات  را وارد کنید."
                label="توضیحات "
                required
                multiline
                minRows={2}
                maxRows={4}
                onChange={(e) => setValue("description", e.target.value)}
                value={watch("description")}
                error={!!errors.description}
                helperText={errors.description?.message}
            />
            <ModalButtonContainer>
                <Button
                    style={NegativeModalButton}
                    sx={{
                        color: "divider",
                        bgcolor: "primary.main",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderColor: "divider",
                        ":hover": {
                            bgcolor: "divider",
                            color: "primary.main"
                        },
                    }}
                    onClick={() => setShow(false)}
                >
                    انصراف
                </Button>
                <Button
                    style={PositiveModalButton}
                    sx={{
                        ":hover": {
                            bgcolor: "customColors.purple",
                            color: "secondary.main"
                        },
                    }}
                >
                    تایید
                </Button>
            </ModalButtonContainer >
        </React.Fragment>
    )
}